import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <>
      <div className='bg'>
        <img className='loader' src='/images/spinnernew.gif' alt='Loader' />
      </div>
    </>
  );
};

export default Loader;
